import { Expose, Type } from 'class-transformer';
import { CompanyTypeDto } from './company-type.dto';
import { BuildingWithLocationModel } from '../../../room/dto/implements/building-with-location.model';

export class CompanyDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'token' })
  token: string;
  @Expose({ name: 'spaces' })
  spaces: number[];
  @Expose({ name: 'location' })
  location: string;
  @Expose({ name: 'lpr_company_id' })
  lprCompanyId: number;
  @Expose({ name: 'company_unique_visit_id' })
  companyUniqueVisitId: string;
  @Expose({ name: 'company_type' })
  @Type(() => CompanyTypeDto)
  companyType: CompanyTypeDto;
  @Expose({ name: 'buildings' })
  @Type(() => BuildingWithLocationModel)
  buildings: BuildingWithLocationModel[];
}
